import { fieldTypeConfig } from '@/enums/preObjectManage'
import { isArray, isJSON, isString } from '@/utils/is'
import { filterEnums } from '@/utils/preObjectManage/utils'
import { getCascadeLabel } from '@/utils/util'
import { getDetaultValue } from '@/apis/objectManage'
import { getPageComponentDataDisplayAcquire } from '@/apis/customerManage'
import { recursion } from '@/utils/tools'
import { getAsoCodeSerialArr } from '@/hooks/useDealAssociatedData'

const quoteObj: Recordable = {}
// 处理引用映射传值问题,模糊匹配
export function createQuoteValueStrategy(quoteObj: Recordable) {
  // 人员单选
  ;[fieldTypeConfig.person].forEach(key => {
    quoteObj[key] = (list: Recordable[], label: string) => {
      console.log(list, label, 'kkk')
      const userVOList = list[0].userVOList
      const arr = userVOList.filter((item: any) => item.realName.indexOf(label) > -1)
      return arr.length ? arr.map((item: any) => item.id).join(',') : ''
    }
  })
  // 下拉单选
  ;[fieldTypeConfig.select].forEach(key => {
    quoteObj[key] = (list: Recordable[], label: string) => {
      const arr = (list || []).filter(item => item.label.indexOf(label) > -1)
      return arr.length ? arr.map(item => item.value).join(',') : ''
    }
  })
  // 多级联动
  ;[fieldTypeConfig.cascader].forEach(key => {
    quoteObj[key] = (list: Recordable[], label: string) => {
      const arr = list.filter(item => (item.stageName || item.label).indexOf(label) > -1)
      return arr.length ? arr.map(item => item.stageValue || item.value).join(',') : ''
    }
  })
  // 客户标签
  ;[fieldTypeConfig.tags].forEach(key => {
    quoteObj[key] = (list: Recordable[], label: string) => {
      const recursionList: Recordable[] = []
      recursion(
        list,
        item => {
          recursionList.push(item)
        },
        { children: 'tagList' }
      )
      const arr = recursionList.filter(item => item.tagName.indexOf(label) > -1)
      return arr.length ? arr.map(item => item.id).join(',') : ''
    }
  })
  return quoteObj
}

export const dealQuoteValueConfig = createQuoteValueStrategy(quoteObj)

const labelObj: Recordable = {}
// 处理引用映射label返现
export function createLabelValueStrategy(labelObj: Recordable) {
  //  下拉框多选
  ;[
    fieldTypeConfig.multipleChoice,
    fieldTypeConfig.checkbox,
    fieldTypeConfig.multipleDepartment,
    fieldTypeConfig.personMultiple
  ].forEach(key => {
    labelObj[key] = (list: Recordable[], val: string) => {
      const tempArrValue: any[] = []
      try {
        if (isArray(JSON.parse(val))) {
          tempArrValue.push(...JSON.parse(val))
        } else {
          tempArrValue.push(...val.split(','))
        }
      } catch (error) {
        console.log('createLabelValueStrategy', error)
      }

      let resultArr: Recordable[] = []
      resultArr = list.filter((item: Recordable) => {
        if (tempArrValue?.includes(String(item.value))) {
          return item
        }
      })
      return resultArr.map((item: Recordable) => item.label).join(',')
    }
  })
  //  下拉框单选
  ;[
    fieldTypeConfig.select,
    fieldTypeConfig.radio,
    fieldTypeConfig.person,
    fieldTypeConfig.department
  ].forEach(key => {
    labelObj[key] = (list: Recordable[], val: string) => {
      console.log(list, val, '123333')
      return filterEnums(String(val), list).label
    }
  })
  //  级联
  ;[fieldTypeConfig.cascader].forEach(key => {
    labelObj[key] = (list: Recordable[], val: string) => {
      return getCascadeLabel(val.split(','), list)
    }
  })
  //  地址
  ;[fieldTypeConfig.address].forEach(key => {
    labelObj[key] = (list: Recordable[], val: string, field: Recordable) => {
      console.log(val, field, 'loooooo1')
      if (val && isJSON(val)) {
        const getTextValue = () => {
          const { pName = '', cName = '', aName = '', detail } = JSON.parse(val)
          if (field.precisions === 1) {
            return pName + cName + aName + detail || '-'
          } else if (field.precisions === 2) {
            return pName + cName + aName || '-'
          } else if (field.precisions === 3) {
            return pName + cName || '-'
          } else if (field.precisions === 4) {
            return pName || '-'
          } else {
            return pName + cName + aName + detail || '-'
          }
        }
        return getTextValue()
      } else {
        return val
      }
    }
  })
  //  标签
  ;[fieldTypeConfig.tags].forEach(key => {
    labelObj[key] = (list: Recordable[], val: string) => {
      console.log(val, 'val221', list)
      const dealVal = isString(val)
        ? val
        : (val as unknown as string).replace(/\d+/g, match => `"${match}"`)
      console.log(JSON.parse(dealVal), 'dealVal222')
      const tempArrValue: any[] = JSON.parse(dealVal)
      console.log(tempArrValue, 'tempArrValue222')
      let resultArr: Recordable[] = []
      resultArr = list.filter((item: Recordable) => {
        if (tempArrValue?.includes(String(item.value))) {
          return item
        }
      })
      console.log(resultArr, 'resultArr222')
      return resultArr.map((item: Recordable) => item.label).join(',')
    }
  })
  return labelObj
}

export const dealLabelValueConfig = createLabelValueStrategy(labelObj)

// 统一在这儿处理关联已有数据的获取
export function getAssociatedData(props: Recordable): Promise<Recordable> {
  const { data, formData, positions } = props
  const asoCodeSerialArr = getAsoCodeSerialArr(positions)

  return new Promise(resolve => {
    const defaultValueConfigInfo = data.defaultValueConfigInfo
    if (defaultValueConfigInfo) {
      const postData = {
        connectColumnSerial: defaultValueConfigInfo.connectColumnSerial,
        connectTableCode: defaultValueConfigInfo.connectTableCode,
        connectType: defaultValueConfigInfo.connectType,
        conditionInfo: defaultValueConfigInfo.conditionInfo,
        sourceTableCode: defaultValueConfigInfo.sourceTableCode,
        sourceTableAlias: defaultValueConfigInfo.sourceTableAlias,
        sourceColumnSerial: defaultValueConfigInfo.sourceColumnSerial,
        sourceTableField: defaultValueConfigInfo.sourceTableField,
        sourceFieldCode: defaultValueConfigInfo.sourceFieldCode,
        sourceFieldType: defaultValueConfigInfo.sourceFieldType,
        sourceDataMark: defaultValueConfigInfo.sourceDataMark,
        tableCode: data.tableCode,
        fieldSerial: data.fieldSerial
      }

      // 关联已有数据---过滤条件字段值处理(带给后端进行精准查询)
      postData.conditionInfo?.conditionList?.forEach((item: Recordable) => {
        item.conditions.forEach((item2: Recordable) => {
          const _obj = asoCodeSerialArr.find(i => i.fieldSerial === item2.rightColumnSerial)
          if (_obj) {
            // 需要取真实值
            const arr = formData[_obj.fieldCode]?.split('$')
            item2.rightValue = JSON.stringify(arr.length ? [arr[arr.length - 1]] : [])
          }
        })
      })

      getDetaultValue(postData).then(res => {
        let listArr: Recordable[] = []
        if (res.dataList && res.dataList.length) {
          listArr = res.dataList.map((item: Recordable) => {
            return {
              defaultQuoteDataId: item.id,
              label: item[defaultValueConfigInfo.connectColumnSerial],
              value:
                item[`D${defaultValueConfigInfo.connectColumnSerial}`] ||
                item[defaultValueConfigInfo.connectColumnSerial]
            }
          })
          // listArr = listArr.filter(item => item.value === 0 ? String(item.value) : item.value)
          Promise.all(
            listArr.map(item => {
              return (async () => {
                // 要处理dataMark
                if (defaultValueConfigInfo.sourceDataMark === 2) {
                  const postData = {
                    columnSerial: defaultValueConfigInfo.sourceColumnSerial,
                    echoData: item.value,
                    tableCode: defaultValueConfigInfo.sourceTableCode
                  }
                  if (item.value) {
                    const res1 = await getPageComponentDataDisplayAcquire({
                      ...postData
                    })
                    item.label = res1.map((item: Recordable) => item.label).join(',')
                  }
                } else if (defaultValueConfigInfo.sourceDataMark === 1) {
                  if (res.valueLabelList && res.valueLabelList.length) {
                    const tempArrValue: any[] = String(item.value).split(',')
                    let resultArr: Recordable[] = []
                    resultArr = res.valueLabelList.filter((item: Recordable) => {
                      if (tempArrValue?.includes(String(item.value))) {
                        return item
                      }
                    })
                    item.label = resultArr.map((item: Recordable) => item.label).join(',')
                  }
                } else {
                  item.label = item.value
                }
                return { ...item }
              })()
            })
          ).then(res => {
            resolve({
              value: res[0]?.value === 0 ? String(res[0]?.value) : res[0]?.value || '',
              list: res
            })
          })
        }
      })
    }
  })
}
